import createIcon from '../../createIcon';

/**
 * @component @name Assistant
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMS41SDVDMy45IDEuNSAzIDIuNCAzIDMuNVYxNy41QzMgMTguNiAzLjkgMTkuNSA1IDE5LjVIOUwxMiAyMi41TDE1IDE5LjVIMTlDMjAuMSAxOS41IDIxIDE4LjYgMjEgMTcuNVYzLjVDMjEgMi40IDIwLjEgMS41IDE5IDEuNVpNMTMuODggMTIuMzhMMTIgMTYuNUwxMC4xMiAxMi4zOEw2IDEwLjVMMTAuMTIgOC42MkwxMiA0LjVMMTMuODggOC42MkwxOCAxMC41TDEzLjg4IDEyLjM4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Assistant = createIcon('Assistant', [
  [
    'path',
    {
      d: 'M19 1.5H5C3.9 1.5 3 2.4 3 3.5V17.5C3 18.6 3.9 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM13.88 12.38L12 16.5L10.12 12.38L6 10.5L10.12 8.62L12 4.5L13.88 8.62L18 10.5L13.88 12.38Z',
      key: 'r9phtj',
    },
  ],
]);

export default Assistant;
